import { formatPrice } from '@ab-core/functions';
import type { PositionPriceObject } from '@ab-core/graphql/dist/index';
import Text from '@ab-core/text';
import type { MoneyObject } from '@ab-core/types/src';
import type { FC } from 'react';
import React from 'react';

type BasePriceType = Pick<PositionPriceObject, 'priceObject' | 'basePrice'> & {
    quantityUnit: string;
};

export const BasePrices: FC<BasePriceType> = (props) => {
    const { priceObject, basePrice, quantityUnit } = props;
    const isInstead =
        priceObject &&
        basePrice &&
        priceObject.priceConditionMemory &&
        priceObject.priceConditionMemory.value &&
        priceObject?.priceConditionMemory?.value?.centAmount - basePrice?.centAmount > 1;

    return (
        <div className="flex-justify-content-space-between">
            <Text
                content={`Preis pro ${priceObject?.priceReference ? priceObject?.priceReference : ''} ${quantityUnit}`}
            />
            {isInstead && (
                <Text className="text-line-through" color="gray50">
                    statt {formatPrice(priceObject?.priceConditionMemory?.value as MoneyObject)}
                </Text>
            )}
            <Text color={isInstead ? 'primary' : 'black'}>{basePrice ? formatPrice(basePrice) : '-'}</Text>
        </div>
    );
};
